import apiClient from "../../../api/apiClient";

/**
 * Fetch all opportunities from the backend
 */
export const fetchOpportunities = async () => {
  try {
    console.log("📡 Fetching Opportunities...");
    const response = await apiClient.get("/opportunities");
    console.log("✅ Opportunities Fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching opportunities:", error);
    throw new Error("Failed to fetch opportunities. Please try again.");
  }
};

/**
 * Fetch a single opportunity by ID
 */
export const fetchOpportunityById = async (opportunityId) => {
  try {
    console.log(`📡 Fetching Opportunity ID: ${opportunityId}`);
    const response = await apiClient.get(`/opportunities/${opportunityId}`);
    console.log("✅ Opportunity Data:", response.data);
    return response.data;
  } catch (error) {
    console.error(`❌ Error fetching opportunity ${opportunityId}:`, error);
    throw new Error(`Failed to fetch opportunity ${opportunityId}.`);
  }
};

/**
 * Create a new opportunity
 */
export const createOpportunity = async (opportunityData) => {
  try {
    console.log('CreateOpportunity Service data:',opportunityData );
    // ✅ Ensure required fields are included
    if (!opportunityData.opportunity_name || !opportunityData.pipeline_stage_id || !opportunityData.status_id) {
      console.log("📡 Creating Opportunity with Data:", opportunityData);
      throw new Error("Opportunity name, pipeline stage, and status are required.");
    }

    console.log("📡 Creating Opportunity with Data:", opportunityData);

    const response = await apiClient.post("/opportunities", opportunityData);

    console.log("✅ Opportunity Created:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API Error creating opportunity:", error.response?.data || error);
    throw new Error(error.response?.data?.message || "Failed to create opportunity.");
  }
};

/**
 * Update an existing opportunity
 */
export const updateOpportunity = async (opportunityId, opportunityData) => {
  try {
    console.log(`📡 Updating Opportunity ID: ${opportunityId}`, opportunityData);
    
    const response = await apiClient.put(`/opportunities/${opportunityId}`, opportunityData);
    
    console.log("✅ Opportunity Updated:", response.data);
    return response.data;
  } catch (error) {
    console.error(`❌ Error updating opportunity ${opportunityId}:`, error.response?.data || error);
    throw new Error(error.response?.data?.message || `Failed to update opportunity ${opportunityId}.`);
  }
};

/**
 * Delete an opportunity
 */
export const deleteOpportunity = async (opportunity_id) => {
  try {
    console.log(`📡 Deleting Opportunity ID: ${opportunity_id}`);
    
    await apiClient.delete(`/opportunities/${opportunity_id}`);
    
    console.log("✅ Opportunity Deleted:", opportunity_id);
    return { message: "Opportunity deleted successfully" };
  } catch (error) {
    console.error(`❌ Error deleting opportunity ${opportunity_id}:`, error.response?.data || error);
    throw new Error(error.response?.data?.message || `Failed to delete opportunity ${opportunity_id}.`);
  }
};

/**
 * Fetch available pipeline stages
 */
export const fetchPipelineStages = async () => {
  try {
    console.log("📡 Fetching Pipeline Stages...");
    
    const response = await apiClient.get("/opportunities/pipeline-stages");
    
    console.log("✅ Pipeline Stages Fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching pipeline stages:", error);
    throw new Error("Failed to fetch pipeline stages.");
  }
};

/**
 * Fetch available opportunity statuses
 */
export const fetchOpportunityStatuses = async () => {
  try {
    console.log("📡 Fetching Opportunity Statuses...");
    
    const response = await apiClient.get("/opportunities/statuses");
    
    console.log("✅ Opportunity Statuses Fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching opportunity statuses:", error);
    throw new Error("Failed to fetch opportunity statuses.");
  }
};

/**
 * Fetch all leads for selection in the form
 */
export const fetchLeads = async () => {
  try {
    console.log("📡 Fetching Leads...");
    
    const response = await apiClient.get("/leads");
    
    console.log("✅ Leads Fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching leads:", error);
    throw new Error("Failed to fetch leads.");
  }
};

/**
 * Fetch all customers for selection in the form
 */
export const fetchCustomers = async () => {
  try {
    console.log("📡 Fetching Customers...");
    
    const response = await apiClient.get("/customers");
    
    console.log("✅ Customers Fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching customers:", error);
    throw new Error("Failed to fetch customers.");
  }
};

/**
 * Fetch all sales reps for assignment
 */
export const fetchSalesReps = async () => {
  try {
    console.log("📡 Fetching Sales Reps...");
    
    const response = await apiClient.get("/users/sales-reps");
    
    console.log("✅ Sales Reps Fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching sales reps:", error);
    throw new Error("Failed to fetch sales reps.");
  }
};